import { runResourceSync } from "services/sync/engine";
import { POLICY } from "services/sync/policies";
import EmployeesService from 'services/employees.service';

export function all({ syncEngine, scope, repository, repositories, params, cached, onCall, onFinally, force }) {
  return runResourceSync(syncEngine, scope, "(all)", {
    cached,
    repository,
    onCall,
    onFinally,
    fetchRemote: ({ lastSyncAt }) => EmployeesService.getEmployeeLines({ lastSyncAt }),
    selectItems: (response) => response.payload,
    selectServerTime: (response) => null,
    mode: "mirror",
    policy: POLICY.TTL,
    ttl: 30 * 60 * 1000,
    force
  });
};